import {Button, Card, message, Space, Tooltip} from "antd";
import React, {useState} from "react";
import './HeaderTile.css'
import {DeleteOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {UtilsService} from "../../services/Utils.service";
import {HttpService} from "../../services/http/Http.service";
import ConfirmModal from "../confirmModal/ConfirmModal";
import {RoutingURL, StatusCodeE} from "../../model/models";
import {HttpErrorService} from "../../services/http/HttpError.service";
import dayjs from "dayjs";
import 'dayjs/locale/it';

dayjs.locale('it');

interface CombinatorCardProps {
    id?: number,
    title: string,
    numberPositions?: number,
    numberAssisted?: number,
    codes?: string[],
    typeList?: string[],
    amount?: number[],
    totalTicket?: number,
    total?: number,
    onDelete?: (id: number) => void,
    totalCost?: number,
    createdAt?: string,
    totalSanction?: number,
    totalInterests?: number
}

export default function HeaderTile(props: CombinatorCardProps) {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const deleteCombinator = async () => {
        try {
            await HttpService.getInstanceAxios().delete(`/simulazione/${props.id}`)
            message.success("Combinatore rimosso con successo!")
            if (props.onDelete && props.id) {
                props.onDelete(props.id)
            }
        } catch (error) {
            HttpErrorService.handle('Errore durante la rimozione del combinatore.', error, true)
            setIsModalOpen(false)
        }
    }

    function goWorkOnPractices(combinator: CombinatorCardProps) {
        if (combinator.id !== undefined) {
            const {onDelete, ...combinatorData} = combinator;
            let url: string = UtilsService.replaceId(RoutingURL.PRACTICES, combinator.id.toString());
            url = UtilsService.replaceStatus(url, StatusCodeE.DA_LAVORARE);
            navigate(url, {state: {combinator: combinatorData}});
        }
    }

    return (
        <>
            <Space direction="vertical" style={{display: 'flex'}}>
                <Card title={
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div style={{fontWeight: "bold", fontSize: "16px"}}>{props.title}</div>
                        {props.createdAt &&
                            <div style={{display: "flex", justifyContent: "flex-end"}}>
                <span className="created-at">
                    <Tooltip title={`creato il ${dayjs(props.createdAt).format("DD/MM/YYYY HH:mm")}`}>
                        creato il {dayjs(props.createdAt).format("D MMMM YYYY")}
                    </Tooltip>
                </span>
                            </div>
                        }
                    </div>
                }
                      className="header-card"
                      styles={{
                          header: {
                              background: "#007A33FF",
                              color: "white",
                              paddingBottom: "8px"
                          }
                      }}
                >
                    <div style={{display: "flex", flexDirection: "column", gap: "8px"}}>
                        <div className={"data-container"}>
                            <b>N° Assistiti:</b> <span>{props.numberAssisted}</span>
                        </div>
                        <div className={"data-container"}>
                            <b>N° Posizioni:</b> <span>{props.numberPositions}</span>
                        </div>
                        <div className={"data-container"}>
                            <b>Codice Esenzione:</b>
                            <span>{props.codes && props.codes?.length > 0 ? props.codes?.join(" - ") : "Tutti"}</span>
                        </div>
                        <div className={"data-container"}>
                            <b>Tipo:</b> <span>{props.typeList?.join(" - ")}</span>
                        </div>
                        <div className={"data-container"}>
                            <b>Ticket:</b> <span>€ {UtilsService.formatNumber(props.totalTicket)}</span>
                        </div>
                        <div className={"data-container"}>
                            <b>Sanzione amministrativa:</b>
                            <span>€ {UtilsService.formatNumber(props.totalSanction)}</span>
                        </div>
                        <div className={"data-container"}>
                            <b>Spese:</b> <span>€ {UtilsService.formatNumber(props.totalCost)} </span>
                        </div>
                        <div className={"data-container"}>
                            <b>Interessi:</b> <span>€ {UtilsService.formatNumber(props.totalInterests)}</span>
                        </div>
                        <div className={"data-container"}>
                            <b>Totale:</b> <span>€ {UtilsService.formatNumber(props.total)}</span>
                        </div>
                    </div>
                    <div className={"button-container"}>
                        <Space>
                            <Button danger
                                    onClick={() => setIsModalOpen(true)}
                                    icon={<DeleteOutlined></DeleteOutlined>}></Button>

                            <Button className="visualize-button"
                                    onClick={() => goWorkOnPractices(props)}>
                                Visualizza
                            </Button>

                        </Space>
                    </div>
                </Card>
            </Space>
            <ConfirmModal
                visible={isModalOpen}
                onConfirm={deleteCombinator}
                onCancel={() => setIsModalOpen(false)}
                title="Elimina combinatore"
                message="Sei sicuro di voler eliminare questo combinatore?"
                confirmText="Sì, elimina"
                cancelText="Annulla"
            />
        </>
    )
}
